import React from "react";
import { Link } from "react-router-dom";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../components/ui/table";

const guitarLevels = [
  {
    id: 1,
    label: "Level 1",
    title: "Initial Basic (Foundation Level)",
    objective:
      "Establish instrument familiarity, rhythmic awareness, pitch recognition and basic musical understanding.",
  },
  {
    id: 2,
    label: "Level 2",
    title: "Intermediate (Developing Control)",
    objective:
      "Develop fluency, coordination, rhythmic precision and theoretical clarity.",
  },
  {
    id: 3,
    label: "Level 3",
    title: "Advanced 1 (Musical Expansion)",
    objective:
      "Build musical expression, technical strength and harmonic understanding.",
  },
  {
    id: 4,
    label: "Level 4",
    title: "Advanced 2 (Artistic Control)",
    objective:
      "Achieve interpretive maturity and integrated technical–theoretical control.",
  },
  {
    id: 5,
    label: "Level 5",
    title: "Professional",
    objective:
      "Demonstrate professional-level performance, stylistic command and theoretical mastery.",
  },
  {
    id: 6,
    label: "Level 6",
    title: "Mastery (Artist / Educator / Performer Level)",
    objective:
      "Certify artistic performance authority, originality and pedagogical understanding.",
  },
];

export default function GuitarSyllabusOverview() {
  return (
    <div className="space-y-8">
      <section className="space-y-3 text-center">
        <h1 className="text-2xl font-semibold tracking-tight text-[#182033]">
          Guitar syllabus – levels 1 to 6
        </h1>
        <p className="mx-auto max-w-3xl text-sm leading-relaxed text-[#4b4a46] sm:text-base">
          The Global Music Conservatory guitar syllabus is organised across six levels,
          from foundational study through to professional artist and educator
          standards. Each level combines practical and theoretical components.
        </p>
      </section>

      <section className="rounded-3xl border border-[#ddcaa4] bg-[#f9f2e6] p-4 shadow-sm lg:p-6">
        <div className="mb-3 flex items-center justify-between">
          <p className="text-xs font-semibold uppercase tracking-[0.22em] text-[#8c7648]">
            Guitar certification levels
          </p>
          <p className="text-[11px] text-[#7b7466]">
            Select a level below to view the detailed syllabus.
          </p>
        </div>

        <div className="overflow-x-auto rounded-2xl border border-[#e1d2b3] bg-[#fdf8ef]">
          <Table>
            <TableHeader className="bg-[#f5ebd9]">
              <TableRow>
                <TableHead className="w-[80px] text-xs font-semibold uppercase tracking-[0.16em] text-[#1f2738]">
                  Level
                </TableHead>
                <TableHead className="text-xs font-semibold uppercase tracking-[0.16em] text-[#1f2738]">
                  Descriptor
                </TableHead>
                <TableHead className="hidden text-xs font-semibold uppercase tracking-[0.16em] text-[#1f2738] md:table-cell">
                  Objective
                </TableHead>
                <TableHead className="w-[140px] text-right text-xs font-semibold uppercase tracking-[0.16em] text-[#1f2738]">
                  Action
                </TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {guitarLevels.map((level) => (
                <TableRow key={level.id} className="text-sm text-[#4b4a46]">
                  <TableCell className="align-top font-semibold text-[#182033]">
                    {level.label}
                  </TableCell>
                  <TableCell className="align-top">
                    {level.title}
                  </TableCell>
                  <TableCell className="hidden align-top md:table-cell">
                    {level.objective}
                  </TableCell>
                  <TableCell className="align-top text-right">
                    <Link
                      to={`/guitar-syllabus/level/${level.id}`}
                      className="inline-flex h-8 items-center justify-center rounded-full border border-[#d5c39d] bg-white px-3 text-[11px] font-semibold uppercase tracking-[0.16em] text-[#1f2738] hover:bg-[#f5ebd9]"
                    >
                      View syllabus
                    </Link>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </section>
    </div>
  );
}
